export default __webpack_public_path__ + "static/30-4664f8b9b115f7f68d5e778abddea0ca.jpg";